module.exports = __webpack_public_path__ + "img/members-right-qz1.6ff36b71.png";